import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const BlogFlower = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios
      .get(`/api/v1/posts`, {
        params: {
          isFooter: false,
          page: 1,
          limit: 4,
        },
      })
      .then((res) => {
        setData(res.data.posts);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="blog-flower-container">
      <div className="blog-flower-title">
        <div className="blog-flower-title-text">
          <i className="bi bi-list me-2"></i>Blog Flowers
        </div>
      </div>
      <div className="blog-flower-content">
        {data.map((item, idx) => (
          <Link to={`/post/${item.slug}`} key={idx}>
            <div className="blog-flower-content-item">
              <div className="item-absulute">
                <div className="blog-flower-img-item">
                  <img src={item.image} alt="" />
                </div>
                <div className="blog-flower-text-overlay">
                  <p>{item.title}</p>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <div
        className="hot-product-view-more mt-4"
        onClick={() => navigate(`/news`)}
      >
        <p>Xem Thêm Tin Tức</p>
        <div className="line"></div>
      </div>
    </div>
  );
};

export default BlogFlower;
